var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-item item--shares",class:_vm.main ? 'group-start' : ''},[_c('div',{staticClass:"item"},[(_vm.item.getUserPrivileges('general.manage_shared_access'))?_c('shares-label',{attrs:{"instance":_vm.item,"showAssignText":"","isIcon":_vm.isIcon}}):_c('div',[_vm._v("-")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }